import { VdsBadgePill, VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';
import styles from './AssetIdentifier.module.scss';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import { ObjectType } from '@casops/store/apis/commonModels';
import { ReactNode } from 'react';
import * as objectTypeSvgs from '@cas/assets/images/object-types/index';
import { AssetDeviceType, DisplayStatus } from '@casops/store/apis/registeredAssetsApi';

interface AssetIdentifierProps {
  showIcon?: boolean;
  name?: string;
  mismatch: boolean;
  deviceType: AssetDeviceType;
  deviceId?: string;
  objectType?: ObjectType;
  isCompact?: boolean;
  vehicleGroupChips: ReactNode;
  displayStatus: DisplayStatus;
}

// Fixme: This function could be removed if the SVGs are imported using a type-safe map.
const getObjectTypeSvg = (objectType: ObjectType): string | undefined => objectTypeSvgs[objectType];

export function AssetIdentifier({
  showIcon,
  name,
  mismatch,
  deviceType,
  objectType,
  deviceId,
  isCompact,
  vehicleGroupChips,
  displayStatus,
}: AssetIdentifierProps) {
  const { t } = useTranslation();
  const isMisMatch = mismatch === false;

  return (
    <div className={styles.container}>
      {showIcon && objectType && (
        <div className={styles.icon}>
          <VdsIcon
            size="var(--spacing-19)"
            style={{ height: 'var(--spacing-19)' }}
            svgIcon={getObjectTypeSvg(objectType)}
            {...(objectType === ObjectType.Unknown
              ? { color: isMisMatch ? 'red-500' : 'color-icon-information' }
              : {})}
          />
        </div>
      )}
      <div className={styles.assetWrapper}>
        <div className={styles.assetTop}>
          <div className={styles.asset}>
            <div className={`${styles.name} ${isMisMatch && styles['name--bad']}`}>
              {name || <Skeleton width="100px" height="34px" />}
              {isMisMatch && (
                <div className={`${styles.toolTip}`}>
                  <VdsTooltip
                    id="sidepanel-asset-name-error"
                    event="hover"
                    max-width="150px"
                    position="bottom"
                    type="standard"
                    text={t('AssetNameMismatch')}
                  >
                    <VdsIcon
                      slot="tooltip-trigger"
                      color="red-500"
                      svgIcon="information"
                      size={isCompact ? '20px' : '24px'}
                    />
                  </VdsTooltip>
                </div>
              )}
            </div>
          </div>
          {deviceType && (
            <div className={styles.hardware}>{t(`AssetDeviceType.${deviceType}`)}</div>
          )}
          {deviceId && <div className={styles.deviceId}>{deviceId}</div>}
          {displayStatus === DisplayStatus.Silent && (
            <VdsBadgePill
              className={styles.fixVdsAlignment}
              icon="mute"
              value={t('SilentMode')}
              statusColor="neutral"
              size="medium"
            />
          )}
        </div>
        {vehicleGroupChips && <div className={styles.vehicleGroups}>{vehicleGroupChips}</div>}
      </div>
    </div>
  );
}

export default AssetIdentifier;
